import React from 'react';
import TestimonialCard from '@/components/TestimonialCard';

const TestimonialsSection = () => {
  return (
    <section className="section-padding bg-gradient-to-b from-card/30 to-background relative">
      <div className="container-wide mx-auto">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <p className="text-primary font-medium tracking-[0.3em] uppercase mb-4 text-sm">
            Testimonials
          </p>
          <h2 className="font-display text-4xl md:text-5xl font-bold mb-6 text-foreground">
            What Our <span className="gradient-text">Clients Say</span>
          </h2>
          <p className="text-lg text-muted-foreground">
            Trusted by automotive enthusiasts, marine engineers, and industrial clients across Canterbury.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          <TestimonialCard
            quote="Precision Vapour transformed my vintage car parts to better than new condition. I was amazed by the results and the quick turnaround time."
            author="James Wilson"
            role="Classic Car Enthusiast"
            delay="0.2s"
          />
          <TestimonialCard
            quote="As a marine engineer, I've tried many cleaning methods, but nothing compares to the quality of Precision Vapour's work. Truly revolutionary."
            author="Sarah Thompson"
            role="Marine Engineer"
            delay="0.3s"
          />
          <TestimonialCard
            quote="The level of detail and care they put into restoring our industrial equipment was exceptional. Highly recommended for any restoration needs."
            author="Michael Johnson"
            role="Manufacturing Manager"
            delay="0.4s"
          />
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
